import React, { Component } from 'react';

import Toolbar from 'base/components/common/Toolbar';

import EventData from '../components/EventData';

import API, { AUTH_HEADER, GET_AUTH } from 'base/api';

export default class EventView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
      error: null
    }
  }

  handleUpdate = (data) => {
    if(window.confirm("Na pewno zaktualizować?")){
      fetch(API.UPDATE_EVENT_INFO, {
        method: 'POST',
        body: JSON.stringify(data), 
        headers: new Headers(AUTH_HEADER)
      })
      .then( res => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then( res => this.setState({ error: res.message, isLoading: false }))
      .catch(error => 
        this.setState({ error: error.message, isLoading: false })
      );
    }
  }

  componentDidMount = () => {
    this.setState({isLoading: true});
    fetch(API.GET_EVENT_INFO, GET_AUTH)
    .then( res => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Something went wrong ...');
      }
    })
    .then(data => this.setState({ data: data, isLoading: false }))
    .catch(error => this.setState({ error, isLoading: false }));
  }

  render() {
    const { data, isLoading, error } = this.state; 
    return (
      <div>
        <Toolbar title="< Panel admina | Event" titleUrl="/admin" />
        <div className="container">
          {
            isLoading 
              ? <p>Loading that shit...</p> 
              : <EventData onSubmit={this.handleUpdate} initialValues={data}  />
          }
          {
            error && <p>{error}</p>
          }
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/Admin/views/EventView.js